var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro"},[_c('h2',[_vm._v("关于一匠")]),_vm._v(" "),_c('p',{staticClass:"intro-desc"},[_vm._v(_vm._s(_vm.about.title))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.about.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d9b031a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/HomeAbout.vue
// module id = null
// module chunks = 